// src/reducers/userSlice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserState {
  isAuthenticated: boolean;
  isRegistrationComplete: boolean;
  isPassedOptional: boolean;
  token: string | null;
}

const initialState: UserState = {
  isAuthenticated: false,
  isRegistrationComplete: false,
  isPassedOptional: false,
  token: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserAuthenticated(state, action: PayloadAction<boolean>) {
      state.isAuthenticated = action.payload;
    },
    setRegistrationComplete(state, action: PayloadAction<boolean>) {
      state.isRegistrationComplete = action.payload;
    },
    setPassedOptional(state, action: PayloadAction<boolean>) {
      state.isPassedOptional = action.payload;
    },
    setToken(state, action: PayloadAction<string | null>) {
      state.token = action.payload;
    },
    resetUserState(state) {
      state.isAuthenticated = false;
      state.isRegistrationComplete = false;
      state.isPassedOptional = false;
      state.token = null;
    },
  },
});

export const {
  setUserAuthenticated,
  setRegistrationComplete,
  setPassedOptional,
  setToken,
  resetUserState,
} = userSlice.actions;
export default userSlice.reducer;
